import * as React from 'react';
export const IcMathematics = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 7a1 1 0 00.71-.29A.998.998 0 0013 6a1.05 1.05 0 00-.29-.71A1.001 1.001 0 0012 5H7a1 1 0 00-1 .68L4.7 9.74l-.87-1.29A1.1 1.1 0 003.19 8a.94.94 0 00-.41 0 .84.84 0 00-.38.15 1 1 0 00-.29.29.93.93 0 00-.11.33 1.12 1.12 0 000 .41 1 1 0 00.19.37l2 3A1 1 0 005 13h.13a1 1 0 00.87-.68L7.72 7H12zm-3 5.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm5 2.5H7a1 1 0 000 2h7a1 1 0 100-2zm-3.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm11.21-8.71A1.001 1.001 0 0021 9h-2V7a1 1 0 00-2 0v2h-2a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 00.71-1.71z'
      fill='currentColor'
    />
  </svg>
);
